import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { PonderAuthClientBase } from "./ponder-auth-client-base";
import { environment } from "../../../environments/environment";

@Injectable( { providedIn: 'root' })
export class PonderAuthClient extends PonderAuthClientBase {
    public constructor(@Inject(HttpClient) httpClient: HttpClient) {
        super(httpClient, `${environment.ponderBaseUrl}/auth`);
    }
}